var app = angular.module("leonardo");

var EditSkinningOptionController = function ($scope, $rootScope, $element) {
    $scope.whitelabelData = angular.copy($scope.ngDialogData.whitelabelData);
    $scope.clientInstance = angular.copy($scope.ngDialogData.clientInstance);
    document.getElementsByTagName('body')[0].classList.add('skinning-option');
    $scope.onSubmitSkining = function (data) {
        $scope.confirm(data);
    }

    $scope.onCancel = function () {
        $scope.closeThisDialog();
    }

    $scope.data = {
        jwt: localStorage.getItem('jwt-token'), id: ($scope.clientInstance && $scope.clientInstance.id), whitelabelItem: $scope.whitelabelData, onSubmitSkining: $scope.onSubmitSkining,
        onCancel: $scope.onCancel
    };

    setTimeout(() => {
        $rootScope.loadReact({
            selector: '#skinning-option-form',
            $element,
            component: window.oldReactComponent.WhiteLabel.SkinningOptionsPage,
            data: $scope.data
        });
    }, 500);

    $scope.$on('$destroy', function () {
        document.getElementsByTagName('body')[0].classList.remove('skinning-option');
        window.oldReduxStore.dispatch(window.oldReduxActions.resetWhiteLabelFilters());
    });
};

app.controller('EditSkinningOptionController', ['$scope', '$rootScope', '$element', EditSkinningOptionController]);
